var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionReciept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20496 0.666748H2.79496C0.58996 0.666748 0.041626 1.25591 0.041626 3.60675V10.1751C0.041626 11.7267 0.893293 12.0942 1.92579 10.9859L1.93163 10.9801C2.40996 10.4726 3.13913 10.5134 3.55329 11.0676L4.14246 11.8551C4.61496 12.4792 5.37913 12.4792 5.85163 11.8551L6.44079 11.0676C6.86079 10.5076 7.58996 10.4667 8.06829 10.9801C9.10663 12.0884 9.95246 11.7209 9.95246 10.1692V3.60675C9.95829 1.25591 9.40996 0.666748 7.20496 0.666748ZM6.74996 6.35425H3.24996C3.01079 6.35425 2.81246 6.15591 2.81246 5.91675C2.81246 5.67758 3.01079 5.47925 3.24996 5.47925H6.74996C6.98913 5.47925 7.18746 5.67758 7.18746 5.91675C7.18746 6.15591 6.98913 6.35425 6.74996 6.35425ZM7.33329 4.02091H2.66663C2.42746 4.02091 2.22913 3.82258 2.22913 3.58341C2.22913 3.34425 2.42746 3.14591 2.66663 3.14591H7.33329C7.57246 3.14591 7.77079 3.34425 7.77079 3.58341C7.77079 3.82258 7.57246 4.02091 7.33329 4.02091Z",
    fill: "#969CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionReciept);
export default __webpack_public_path__ + "static/media/transaction_reciept.9b2dfd9b7160b54a69bc373d9e45f10b.svg";
export { ForwardRef as ReactComponent };